import { Slider as NextSlider } from "@heroui/react";
import { withFormComponent } from "./hoc";

export const Slider = withFormComponent(NextSlider); 